import React from 'react'
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { showBrowserPopup } from '../../action/action';

class LinkPopup extends React.Component {

  onNoClick = () => {
    this.props.showBrowserPopup(false);
  }

  launchBrowser = (browser) =>{
    window.plugins.launcher.launch({
      uri: `${browser.uri}${browser.url}`,
    }, ()=>{console.log("launched a link")}, ()=>{console.log("error while launching link")});
  }

  render() {
    return (
      <div class="overlay">
        <div id="svc" className="overlay-body" style={{padding:0}}>
          <div className="overlay-close" onClick={this.onNoClick}>
            <i className="fa fa-close">
              <img
                style={{
                  width: '22px',
                  height: '28px'
                }}
                src={require('../../images/icon/fill.svg')}
                alt="" />
            </i>
          </div>
          <div className="primary-response center">
            <div className="wide" style={{ fontSize: '20px' }}>
              {
                this.props.browsersListPopup.browserList.length > 0 ?
                  this.props.browsersListPopup.browserList.map((iterator)=>{
                    return <div onClick={()=>{this.launchBrowser(iterator)}}>
                      {iterator.browserName}
                    </div>
                  }) : ""
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    //browserList
    browsersListPopup: state.store.browserListPopup
  }
}

LinkPopup.propTypes = {
  browsersListPopup: propTypes.bool
}

export default connect(
  mapStateToProps,
  {
    showBrowserPopup
  }
)(LinkPopup);